import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Experience } from "./interfaces";
import copy from "copy-to-clipboard";

interface ItemProps {
  experience: Experience;
  companyName: string;
}

const ExperienceItem = ({
  experience,
  companyName,
}: ItemProps): JSX.Element | null => {
  const [copied, setCopied] = useState(false);
  const embedLink = `https://imp-master-p3d-embed.web.app/${experience.id}`;
  const year = new Date().getFullYear();
  const isNew = experience.year > year;
  useEffect(() => {
    if (!copied) {
      return;
    }
    const timeout = setTimeout(() => {
      if (timeout) {
        clearTimeout(timeout);
      }
      setCopied(false);
    }, 3000);
  }, [copied]);
  return (
    <li className="experience-item" key={`experience-item-${experience.id}`}>
      <div className={`experience-item-box ${isNew ? 'experience-new' : ''}`}>
        <Link to={`/${companyName}/${experience.id}`}>
          <div className="experience-item-preview preview-single">
            <img
              src={`${experience.thumbnail}`}
              alt={`${experience.name} thumbnail`}
            />
          </div>
        </Link>
        <Link to={`/${companyName}/${experience.id}`}>
          <div className="experience-item-title" title={experience.name}>
            {experience.name}
          </div>
        </Link>
        {embedLink ? (
          <div className="experience-item-ar-box">
            <button
              type="button"
              onClick={() => {
                copy(embedLink);
                setCopied(true);
              }}
              className="button experience-item-ar-button"
              title="Click to copy the link to this experience"
            >
              Copy Link
            </button>
          </div>
        ) : (
          ""
        )}
        <div
          className={`experience-message experience-message-success ${copied ? "visible" : ""}`}
        >
          Link copied to clipboard
        </div>
      </div>
    </li>
  );
};

export default ExperienceItem;
